<template>
  <div class="container-fluid page-container">
    <div class="row m-auto col-md-9 px-0 shadow rounded">
      <b-jumbotron class="h1 w-100 mb-0 font-weight-bold" v-html="pageTitle" />
      <b-card-body class="p-3 d-block" v-html="pageContent" />
    </div>
  </div>
</template>

<script>
import company from "@/imports/mixins/company";

export default {
  name: "Covid",
  mixins:[company],
  data() {
    return {
      contentKey: 'covid-19',
      pageContent: null,
      pageTitle: 'Coronavirus',
    }
  },
  methods: {
    getPageContent() {
      const communicationsLanguage = this.company?.communications_language?.iso_code ?? 'en';
      this.$api.page.getPageContent(communicationsLanguage).then((response) => {
        const responseData = response.data;
        let content = responseData.find(page => page.url === this.contentKey);
        this.pageTitle = content.title;
        this.pageContent = content.body;
      });
    }
  },
  mounted() {
    this.getPageContent();
  }
}
</script>

<style scoped>

</style>
